// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { range } from 'lodash'
import { Select } from 'antd'
import { formatDayInMonth } from '../../utils/time'

const TimeBasedIntervalRange = range(1, 3601)
const DistanceBasedIntervalRange = range(5, 1001)
const UploadIntervalRange = range(30, 1801)
const DataQuataRange = range(1, 31)
const AlertThresholdRange = range(5, 105, 5)
const HardThresholdRange = range(5, 105, 5)
const CycleStartDateRange = range(2, 32)

export const CycleStartDateOptions = CycleStartDateRange.map(i => {
  return (
    <Select.Option value={i} key={i} disabled={i > 28}>
      {i}
      {formatDayInMonth(i)}
    </Select.Option>
  )
})

export const TimeBasedIntervalOptions = TimeBasedIntervalRange.map(i => (
  <Select.Option value={i} key={i}>
    Every {i}s
  </Select.Option>
))
export const DistanceBasedIntervalOptions = DistanceBasedIntervalRange.map(i => (
  <Select.Option value={i} key={i}>
    Every {i}m
  </Select.Option>
))
export const UploadIntervalOptions = UploadIntervalRange.map(i => (
  <Select.Option value={i} key={i}>
    Every {i}s
  </Select.Option>
))
export const DataQuataOptions = DataQuataRange.map(i => (
  <Select.Option value={i} key={i}>
    {i}GB
  </Select.Option>
))
export const AlertThresholdOptions = AlertThresholdRange.map(i => (
  <Select.Option value={i} key={i}>
    {i}%
  </Select.Option>
))
export const HardThresholdOptions = HardThresholdRange.map(i => (
  <Select.Option value={i} key={i}>
    {i}%
  </Select.Option>
))

export { MonitorDashboard } from './MonitorDashboard'
